import { useLocation, useMatch, useNavigate } from 'react-router-dom';
import { EditorModus } from '../EditDialog/EditDialog';
import History from 'history';
import { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState, } from 'react';
import { FetchArg, SortParam } from '../../../../api/rtk-queries/queryApiCreator';
import { Filter } from '../../../utils/filter';
import { GridColDef, GridColumns, GridSortModel, } from '@mui/x-data-grid-pro';
import { LAST_PAGE_URL } from '../../../utils/routes';
import { meQueryApiService } from '../../../../api/rtk-queries/extensions/meQueryApiService';
import { useAppDispatch } from '../../../store';
import { Column, ColumnSettings } from '../../../../models';
import { useHentTilgangstypeForNode } from '../../../utils/auth';
import { TilgangstypeEnum } from '../../../../models/Enum/Tilgangstype';


export function useQueryParams<T = unknown>(location: History.Location<T>) {
    if (!location.search) {
        return {};
    }

    const queryParams = location.search
        .substring(1)
        .split('&')
        .map(kvp => kvp.split('='));

    const result: { [key: string]: string[] } = {};
    for (const [key, value] of queryParams) {
        if (key in result) {
            result[key].push(decodeURIComponent(value));
        } else {
            result[key] = [decodeURIComponent(value)];
        }
    }
    return result;
}

export type DataGridRoutes = {
    dialog: 'edit' | 'log' | false;
    editMode: EditorModus;
    entityId?: string | number;
    logId?: number;
    searchTerm?: string;

    navView: (id: string | number) => void;
    navLog: (id: string | number) => void;
    navLogDetails: (id: string | number, logId: number) => void;
    navEdit: (id: string | number) => void;
    navCopy: (id: string | number) => void;
    navCreateChild: (id: string | number) => void;
    navCreate: () => void;
    navList: () => void;
    navSearch: () => void;
    navQuery: (query: string, navList?: boolean) => void;
};

let currentRoutes: DataGridRoutes | undefined;
const r = new EventTarget();
const evtType = 'routes';

export function useDataGridRoutes(): DataGridRoutes {
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = useQueryParams(location);
    const pathUrl = location.pathname.split('/')[1];
    localStorage.setItem(LAST_PAGE_URL, location.pathname);

    const result: DataGridRoutes = {
        dialog: false,
        searchTerm: queryParams.q?.join(' '),
        editMode: EditorModus.IkkeNoen,

        // navList: () => navigate(`/${pathUrl}` + location.search),
        // navEdit: id => navigate(`/${pathUrl}/${encodeURIComponent(id)}${location.search}`),
        // navView: id => navigate(`/${pathUrl}/${encodeURIComponent(id)}/view${location.search}`),
        // navLog: id => navigate(`/${pathUrl}/${encodeURIComponent(id)}/log${location.search}`),
        // navLogDetails: (id, logId) => navigate(`/${pathUrl}/${encodeURIComponent(id)}/log/${encodeURIComponent(logId)}${location.search}`),
        // navCopy: id =>
        //     navigate(`/${pathUrl}/${encodeURIComponent(id)}/copy${location.search}`),
        // navCreate: () => navigate(`/${pathUrl}/create${location.search}`),
        // navCreateChild: id =>
        //     navigate(`/${pathUrl}/${encodeURIComponent(id)}create${location.search}`),
        // navSearch: () => navigate(`/${pathUrl}/search${location.search}`),
        // navQuery(query: string, navList: boolean = false) {
        //     const q = query ? `?q=${encodeURIComponent(query)}` : '';
        //     if (navList) {
        //         navigate(`/${pathUrl}${q}`);
        //     } else {
        //         navigate(q);
        //     }
        // },
        navList: () => navigate(`/${pathUrl}` + location.search),
        navEdit: id => navigate(`/${pathUrl}/${encodeURIComponent(id)}${location.search}`),
        navView: id => navigate(`/${pathUrl}/${(id)}/view${location.search}`),
        navLog: id => navigate(`/${pathUrl}/${encodeURIComponent(id)}/log${location.search}`),
        //navLog: id => navigate(`/${pathUrl}/${id}/log${location.search}`),
        navLogDetails: (id, logId) => navigate(`/${pathUrl}/${encodeURIComponent(id)}/log/${encodeURIComponent(logId)}${location.search}`),
        navCopy: id =>
            navigate(`/${pathUrl}/${encodeURIComponent(id)}/copy${location.search}`),
        navCreate: () => navigate(`/${pathUrl}/create${location.search}`),
        navCreateChild: id =>
            navigate(`/${pathUrl}/${encodeURIComponent(id)}/create${location.search}`),
        navSearch: () => navigate(`/${pathUrl}/search${location.search}`),
        navQuery(query: string, navList: boolean = false) {
            const q = query ? `?q=${(query)}` : '';
            if (navList) {
                navigate(`/${pathUrl}${q}`);
            } else {
                navigate(q);
            }
        },
    };

    const editMatch = useMatch(`/${pathUrl}/:id`);
    const viewMatch = useMatch(`/${pathUrl}/:id/view`);
    const logMatch = useMatch(`/${pathUrl}/:id/log/*`);
    const logDetailsMatch = useMatch(`/${pathUrl}/:id/log/:logId`);
    const copyMatch = useMatch(`/${pathUrl}/:id/copy`);
    const createMatch = useMatch(`/${pathUrl}/create`);
    const createChildMatch = useMatch(
        `/${pathUrl}/:id/create`
    );
    const searchMatch = useMatch(`${pathUrl}/search`);

    if (logMatch) {
        result.dialog = 'log';
        result.entityId = decodeURIComponent(logMatch.params.id ?? '');
        if (logDetailsMatch) {
            result.editMode = EditorModus.Vis;
            result.logId = Number(logDetailsMatch.params.logId);
        }
    } else if (copyMatch) {
        result.dialog = 'edit';
        result.editMode = EditorModus.Kopi;
        result.entityId = decodeURIComponent(copyMatch.params.id ?? '');
    } else if (createMatch) {
        result.dialog = 'edit';
        result.editMode = EditorModus.Opprett;
    } else if (searchMatch) {
        result.dialog = 'edit';
        result.editMode = EditorModus.Soek;
    } else if (createChildMatch) {
        result.dialog = 'edit';
        result.editMode = EditorModus.OpprettBarn;
        result.entityId = decodeURIComponent(createChildMatch.params.id ?? '');
    } else if (editMatch) {
        result.dialog = 'edit';
        result.editMode = EditorModus.Endre;
        result.entityId = decodeURIComponent(editMatch.params.id ?? '');
    } else if (viewMatch) {
        result.dialog = 'edit';
        result.editMode = EditorModus.Vis;
        result.entityId = decodeURIComponent(viewMatch.params.id ?? '');
    }

    currentRoutes = result;
    r.dispatchEvent(new Event(evtType));

    return result;
}

type GridPaginationProps<T> = {
    count?: number;
    defaultPageSize?: number;
    setArgs: Dispatch<SetStateAction<FetchArg<T>>>;
    prefetch?: (arg: any) => void;
    refetch?: (arg: FetchArg<T>) => void;
    defaultFilter?: Filter;
};
//filter: {parameters : filter.find(i => i.selected)?.filter}
export function useDataGridPagination<T extends { id: number | string }>(
    { count, setArgs, prefetch, defaultPageSize, defaultFilter, refetch }: GridPaginationProps<T>
) {
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(0);
    const { searchTerm, navQuery, } = useDataGridRoutes();
    const [sortModel, setSortModel] = useState<GridSortModel>();
    const [currentFilter, setCurrentFilter] = useState<{ parameters: Filter }>({ parameters: defaultFilter ?? {} as Filter });

    useEffect(() => {
        if (setArgs && pageSize > 0) {
            const skip = page * pageSize;
            setArgs(prev => {
                return {
                    ...prev,
                    param: {
                        skip: skip > 0 ? skip : 0,
                        top: pageSize,
                        orderColumn: sortModel?.[0]?.field,
                        ascending: sortModel?.[0]?.sort ? sortModel[0]?.sort === 'asc' ? true : false : undefined
                    },
                    filter: currentFilter
                };
            });
        }
    }, [pageSize, setArgs, currentFilter, page, sortModel]);

    useEffect(() => {
        if (setArgs) {
            setArgs(prev => {
                return {
                    ...prev,
                    query: searchTerm,
                };
            });
        }
    }, [searchTerm, setArgs]);

    useEffect(() => {
        if (defaultPageSize) {
            setPageSize(defaultPageSize);
        }
    }, [defaultPageSize]);


    const prefetchNextCallback = useCallback(() => {
        if (prefetch) {
            const skip = (page + 1) * pageSize;
            if (count && skip < count) {
                prefetch({
                    param: {
                        skip, top: pageSize,
                        orderColumn: sortModel?.[0]?.field,
                        ascending: sortModel?.[0]?.sort ? sortModel[0]?.sort === 'asc' ? true : false : undefined
                    },
                    query: searchTerm,
                    filter: currentFilter
                });
            }
        }
    }, [pageSize, count, prefetch, currentFilter, sortModel, page, searchTerm]);

    const refresh = useCallback(() => {
        setPage(0);
        navQuery('', true);
        const refreshArgs: FetchArg<T> = {
            param: {
                skip: 0,
                top: pageSize,
                orderColumn: sortModel?.[0]?.field,
                ascending: sortModel?.[0]?.sort ? sortModel[0]?.sort === 'asc' ? true : false : undefined
            },
            filter: currentFilter,
            query: undefined
        };
        setArgs(refreshArgs);
        refetch?.(refreshArgs);
    }, [setPage, navQuery, currentFilter, sortModel, pageSize, refetch, setArgs]);

    return {
        refresh,
        prefetchNextCallback,
        page: page < 0 ? 0 : page,
        setPageSize,
        setPage,
        pageSize,
        sortModel,
        setSortModel,
        currentFilter,
        setCurrentFilter
    };
}


export function useEditPanelDragger(editPanelWidth: number, setEditPanelWidth: (val: number) => void) {
    const [width, setWidth] = useState(editPanelWidth);
    const [isDragging, setIsDragging] = useState(false);


    useEffect(() => {
        if (!isDragging) return;

        function mousemoveHandler(evt: MouseEvent): void {
            setWidth(window.innerWidth - evt.pageX);
        }

        window.addEventListener('mousemove', mousemoveHandler, { passive: true });
        return () => {
            window.removeEventListener('mousemove', mousemoveHandler);
        };
    }, [isDragging]);


    useEffect(() => {
        if (editPanelWidth) setWidth(editPanelWidth);
    }, [editPanelWidth]);

    useEffect(() => {
        function mouseupHandler(): void {
            if (editPanelWidth !== width && isDragging) {
                setEditPanelWidth(width);
            }

            setIsDragging(false);
        }
        window.addEventListener('mouseup', mouseupHandler, { passive: true });
        return () => {
            window.removeEventListener('mouseup', mouseupHandler);
        };
    }, [editPanelWidth, width, setEditPanelWidth, isDragging]);


    return {
        width,
        isDragging,
        setIsDragging,
    };

}

export type DataGridSettings = {
    columns: GridColDef[];
    gridId: string | undefined;
    disableColumnSettings?: boolean;
    disableColumnVisibilitySaving?: boolean;
    defaultWidth?: number,
    defaultFlex?: number,
    defaultResizable?: boolean;
    defaultSortParam?: SortParam;
};

export function useDataGridSettings({ columns, gridId, disableColumnSettings, disableColumnVisibilitySaving, defaultFlex, defaultResizable = true, defaultWidth = 200, defaultSortParam }: DataGridSettings) {
    const dispatch = useAppDispatch();
    const [configuredColumns, setConfiguredColumns] = useState<GridColumns>(columns);
    const [settingsTable, setSettingsTable] = useState<ColumnSettings>({} as ColumnSettings);
    const { data: tableSettings, isFetching } = meQueryApiService.useHentTableSettingsQuery(
        gridId!,
        { skip: !gridId }
    );

    const loadedSettings = useRef(false);
    const [saveTableSettings] = meQueryApiService.useSetTableSettingsMutation();
    const pageSizeSetting = tableSettings?.pageSize;

    function resetColumnSettings() {
        if (!gridId) return;
        const settings = {
            ...tableSettings,
            columns: [],
            orderColumn: defaultSortParam?.orderColumn,
            ascending: defaultSortParam?.ascending
        } as ColumnSettings;

        setConfiguredColumns(columns.map(col => applyColumnSetting(col, undefined)));
        saveTableSettings({ id: gridId, columns: settings });
        setSettingsTable(settings);
    }


    const saveSettings = useCallback((data?: ColumnSettings) => {
        if (data && gridId) {
            saveTableSettings({ id: gridId, columns: data });
            setSettingsTable(data);
        }
    }, [saveTableSettings, gridId]);

    const updateSettingsColumn = useCallback(
        (newColumns: GridColDef[]) => {
            if (disableColumnSettings || !gridId) return;
            const columnSettings = (newColumns ?? configuredColumns).map(i => {
                return {
                    columnId: i.field,
                    visible: !i.hide,
                    width: i.width ? Math.floor(i.width) : null,
                } as Column;
            });
            const settings = {
                ...settingsTable,
                columns: columnSettings,
            } as ColumnSettings;
            setConfiguredColumns(newColumns);
            saveTableSettings({ id: gridId, columns: settings });
            setSettingsTable(settings);
        },
        [
            configuredColumns,
            disableColumnSettings,
            gridId,
            saveTableSettings,
            settingsTable,
        ]
    );

    const applyColumnSetting = useCallback((column: GridColDef, setting?: Column) => {
        let newCol: GridColDef = {
            ...column,
            hide: !disableColumnVisibilitySaving && setting ? !setting.visible : column.hide
        } as GridColDef;

        const width = (setting ? setting.width : newCol.width);
        newCol.width = typeof width === 'number' ? width : defaultWidth;
        if (typeof newCol.resizable === 'undefined') newCol.resizable = defaultResizable;
        if (typeof newCol.flex === 'undefined') newCol.flex = defaultFlex;

        return newCol;
    }, [defaultFlex, defaultResizable, disableColumnVisibilitySaving, defaultWidth]);


    useEffect(() => {
        loadedSettings.current = false;
    }, [gridId]);


    useEffect(() => {
        if (loadedSettings.current || isFetching) return;
        if (tableSettings) {
            const configure = async () => {
                setSettingsTable(tableSettings);
                if (!tableSettings.columns?.length) {
                    setConfiguredColumns(columns.map(col => applyColumnSetting(col, undefined)));
                } else {
                    const result = tableSettings.columns
                        .map(cSettings => ({
                            cSettings,
                            column: columns.find(
                                j => j.field === cSettings.columnId
                            ),
                        }))
                        .map(({ column, cSettings }) => applyColumnSetting(column ?? {} as GridColDef, cSettings));
                    setConfiguredColumns(result);
                }
            };
            configure();
            loadedSettings.current = true;
        }
        else {
            setConfiguredColumns(columns.map(col => applyColumnSetting(col, undefined)));
        }

    }, [columns, dispatch, tableSettings, applyColumnSetting, isFetching]);




    return { resetColumnSettings, updateSettingsColumn, configuredColumns, setConfiguredColumns, settingsTable, pageSizeSetting, tableSettings, saveSettings, isFetchingSetting: isFetching || !loadedSettings.current };
}


function checkFullPermission(permissions: TilgangstypeEnum, extendSimpleAccess?: boolean) {
    return (permissions === TilgangstypeEnum.LeseOgRedigere) || (permissions === TilgangstypeEnum.LeseOgRedigereEnkeltElementer && (extendSimpleAccess ?? false));
}

function checkEditSimpleElementsPermission(permissions: TilgangstypeEnum) {
    return permissions === TilgangstypeEnum.LeseOgRedigereEnkeltElementer;
}
//canCreate,canEdit,canDelete,canCopy - general ability to make changes, it`s set from AdmDataGrid
//extendSimpleAccess - if the user in the permision has LeseOgRedigereEnkeltElementer = 20, for local user is working - ok

export function useRegisterAccessRightsEvaluation(params: { registerId: string, canCreate?: boolean, canEdit?: boolean, canDelete?: boolean, canCopy?: boolean, extendSimpleAccess?: boolean }) {
    const permissions = useHentTilgangstypeForNode(params.registerId);
    const evaluatePermission = useCallback((action?: boolean) => {
        const hasFullPermission = checkFullPermission(permissions, params.extendSimpleAccess);
        if (typeof action === 'boolean') return hasFullPermission && action;
        return hasFullPermission;
    }, [params.extendSimpleAccess, permissions]);

    const evaluateEditPermission = useCallback((action?: boolean) => {
        const hasFullPermission = checkFullPermission(permissions, params.extendSimpleAccess);
        const hasEditSimpleElementsPermission = checkEditSimpleElementsPermission(permissions);
        if (typeof action === 'boolean') return (hasFullPermission || hasEditSimpleElementsPermission) && action;
        return hasFullPermission || hasEditSimpleElementsPermission;
    }, [permissions, params.extendSimpleAccess]);


    return ({
        canEdit: evaluateEditPermission(params.canEdit),
        canCreate: evaluatePermission(params.canCreate ?? params.canEdit),
        canDelete: evaluatePermission(params.canDelete ?? params.canCreate ?? params.canEdit),
        canCopy: evaluatePermission(params.canCopy ?? params.canCreate ?? params.canEdit)
    });


}
